/* 🤖 this file was generated by script */
export const wiconListAlt = {
  name: 'list_alt',
  data: `<svg viewBox="0 0 20 21"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M3.16 6.29h5.26m2.63 0h5.8M3.14 10.5h5.27m2.63 0h5.8m-13.7 4.21h5.27m2.63 0h5.8"/></svg>`,
};
